import createFieldArray from '../createFieldArray';
import immutable from '../structure/immutable';

export default createFieldArray(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/FieldArray.js
// module id = 1191
// module chunks = 0